document.addEventListener('DOMContentLoaded', function() {
 
  // SEU TOKEN MAPBOX
  mapboxgl.accessToken = 'pk.eyJ1IjoidHNtMjcxMTg3IiwiYSI6ImNtZDNheTlwYjAybW4yam9sb3U2MWk4eWIifQ.wTcSHzX64dQvClsWdaF2cw';
 
  // Variáveis Globais
  const initialStyleUrl = 'mapbox://styles/tsm271187/cm3t7rx4v006x01s23ggu7wjk';
  let selectedStyleName = 'Padrão';
  let selectedTextColor = '#000000';
  let marker = null;
  let lastSearchedLngLat = null;
  let map = null;
  let calibratedMapState = { zoom: null, width: 0 };
 
  // =================================================================== */
  //                     FUNÇÃO: ROLAGEM AUTOMÁTICA (UX MOBILE)          */
  // =================================================================== */
  function scrollToMapPreview() {
      if (window.innerWidth <= 990) {
          const mapContainer = document.getElementById('poster-map-container') || document.getElementById('poster-map');
          if (mapContainer) {
              const y = mapContainer.getBoundingClientRect().top + window.scrollY - 80;
              window.scrollTo({ top: y, behavior: 'smooth' });
          }
      }
  }
 
  // =================================================================== */
  //                     CATÁLOGO DE PINS ATUALIZADO E COMPLETO          */
  // =================================================================== */
  const pinOptions = {
      'heart': { name: 'Coração', iconClass: 'fas fa-heart', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/pin_heart.png' },
      'house': { name: 'Casa', iconClass: 'fas fa-house', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/pin_home.png' },
      'mochila': { name: 'Mochila', iconClass: 'bi bi-backpack2-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/backpack2-fill.png?v=1752764105' },
      'balao': { name: 'Balão', iconClass: 'bi bi-balloon-heart-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/balloon-heart-fill.png?v=1752764104' },
      'bussola': { name: 'Bússola', iconClass: 'bi bi-compass', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/compass.png?v=1752764105' },
      'pin2': { name: 'Pin II', iconClass: 'bi bi-geo-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/geo-fill.png?v=1752764105' },
      'alfinete': { name: 'Alfinete', iconClass: 'bi bi-pin-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/pin-fill.png?v=1752764105' },
      'mala': { name: 'Mala', iconClass: 'bi bi-suitcase2-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/suitcase2-fill.png?v=1752764105' },
      'aviao': { name: 'Avião', iconClass: 'bi bi-airplane-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/airplane-fill.png?v=1752764105' },
      'carro': { name: 'Carro', iconClass: 'bi bi-car-front-fill', imageUrl: 'https://cdn.shopify.com/s/files/1/0665/6163/8554/files/car-front-fill.png?v=1752764104' }
  };
 
  const OUTPUT_WIDTH = 905;  
  const OUTPUT_HEIGHT = 1280;
  const USE_AT_2X = true;    
 
  const mapContainer = document.getElementById('poster-map');
  if (!mapContainer) { console.error("Container #poster-map não encontrado."); return; }
 
  const productType = window.mapConfig ? window.mapConfig.productType : '';
 
  // =================================================================== */
  //                     GESTOR DE PRÉ-CONFIGURAÇÕES (CAMPANHAS)         */
  // =================================================================== */
  const currentPath = window.location.pathname.split('/').pop().toLowerCase();
 
  let activeConfig = {
      center: [-43.186630, -22.925426], // Padrão: Rio
      pinPosition: null,
      zoomDesktop: 10,
      zoomMobile: 9.38,
      titulo: "Rio de Janeiro",
      subtitulo: "Brasil",
      coordsText: "-22.909534° / -43.209934°",
      pinType: "none",
      fonte: "fonte1",
      styleName: "Padrão",
      modelo: "modelo-2",
      moldura: "moldura-preta"
  };


  if (currentPath === 'quadro-paris-campanha') {
      activeConfig = {
          center: [2.333333, 48.861111], pinPosition: [2.333333, 48.861111],
          zoomDesktop: 15, zoomMobile: 14.38,
          titulo: "O Nosso Encontro", subtitulo: "Paris, França", coordsText: "48.861111° / 2.333333°",
          pinType: "heart", fonte: "fonte2", styleName: "Taupe", modelo: "modelo-2", moldura: "moldura-madeira"
      };
  } else if (currentPath === 'estadio-sao-januario') {
      activeConfig = {
          center: [-43.2297706, -22.8907312], pinPosition: [-43.2283366, -22.8905685],
          zoomDesktop: 15.29, zoomMobile: 14.67,                  
          titulo: "Estádio de são januario", subtitulo: "Barreira do Vasco, Rio de janeiro, brasil", coordsText: "-22.890568° / -43.228337°",
          pinType: "pin2", fonte: "fonte1", styleName: "Ônix", modelo: "modelo-2", moldura: "moldura-preta"            
      };
  } else if (currentPath === 'quadro-casamento-praia') {
      activeConfig = {
          center: [-45.358056, -23.776111], pinPosition: [-45.358056, -23.776111],
          zoomDesktop: 14, zoomMobile: 13.38,
          titulo: "Onde Dissemos Sim", subtitulo: "Ilhabela, SP", coordsText: "-23.776111° / -45.358056°",
          pinType: "balao", fonte: "fonte1", styleName: "Bege", modelo: "modelo-1", moldura: "moldura-branca"
      };
  }


  let currentInitialZoom = activeConfig.zoomDesktop;
  if (window.innerWidth <= 768) {
      currentInitialZoom = activeConfig.zoomMobile;
  }
 
  try {
    map = new mapboxgl.Map({
      container: 'poster-map',
      style: initialStyleUrl,
      center: activeConfig.center,
      zoom: currentInitialZoom,
      preserveDrawingBuffer: true,
      attributionControl: false,
      dragRotate: false,      
      pitchWithRotate: false,  
      touchPitch: false,      
      touchRotate: false,
      projection: 'mercator' // FIX: Trava o mapa no modo plano (sem globo)
    });
  } catch (error) {
      console.error("Falha ao inicializar o mapa Mapbox:", error);
      return;
  }
 
  function addOrUpdateHiddenInput(form, name, value) {
      if (!form) return;
      let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
      if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
      }
      input.value = value;
  }
 
  function setInitialPreview() {
      document.getElementById('titulo').value = activeConfig.titulo;
      document.getElementById('subtitulo').value = activeConfig.subtitulo;
      document.getElementById('coordenadas').value = activeConfig.coordsText;
   
      document.getElementById('preview-titulo').textContent = activeConfig.titulo;
      document.getElementById('preview-subtitulo').textContent = activeConfig.subtitulo;
   
      const previewCoordenadas = document.getElementById('preview-coordenadas');
      const hideCoordinatesCheckbox = document.getElementById('hide-coordinates');
      if (previewCoordenadas) {
          previewCoordenadas.textContent = activeConfig.coordsText;
          if (hideCoordinatesCheckbox && hideCoordinatesCheckbox.checked) {
              previewCoordenadas.style.display = 'none';
          }
      }


      const pinSelect = document.getElementById('pin-select');
      if(pinSelect) pinSelect.value = activeConfig.pinType;
     
      const fontSelect = document.getElementById('font-select');
      if(fontSelect) fontSelect.value = activeConfig.fonte;


      const modeloSelect = document.getElementById('modelo-select');
      if(modeloSelect) {
          modeloSelect.value = activeConfig.modelo;
          const visualOptions = document.querySelectorAll('.visual-model-option');
          visualOptions.forEach(opt => {
              opt.classList.remove('selected');
              if(opt.dataset.model === activeConfig.modelo) opt.classList.add('selected');
          });
      }


      const colorSwatches = document.querySelectorAll('.color-options .color-swatch');
      if(colorSwatches.length > 0) {
          colorSwatches.forEach(s => s.classList.remove('active'));
          const targetSwatch = Array.from(colorSwatches).find(s => s.dataset.styleName === activeConfig.styleName);
         
          if(targetSwatch) {
              targetSwatch.classList.add('active');
              selectedStyleName = targetSwatch.dataset.styleName;
              selectedTextColor = targetSwatch.dataset.textColor;
              if(targetSwatch.dataset.styleUrl && targetSwatch.dataset.styleUrl !== initialStyleUrl) {
                   map.setStyle(targetSwatch.dataset.styleUrl);
              }
              const colorNameDisplay = document.getElementById('selected-color-name');
              if (colorNameDisplay) colorNameDisplay.textContent = `Cor: ${activeConfig.styleName}`;
          }
      }


      const frameSelect = document.getElementById('frame-select');
      if(frameSelect) {
          const frameOption = Array.from(frameSelect.options).find(opt => opt.value === activeConfig.moldura);
          if(frameOption) frameSelect.value = activeConfig.moldura;
      }
  }
 
  let lastKnownMarkerPosition = null;
 
  function updateMapMarker() {
      if (marker) {
          marker.remove();
          marker = null;
      }
      const pinSelect = document.getElementById('pin-select');
      if (!pinSelect) return;
      const pinType = pinSelect.value;
      if (pinType === 'none') {
          lastKnownMarkerPosition = null;
          return;
      }
     
      const position = lastKnownMarkerPosition || lastSearchedLngLat || activeConfig.pinPosition || map.getCenter();
     
      const onDragEnd = () => {
          const lngLat = marker.getLngLat();
          const coordText = `${lngLat.lat.toFixed(6)}° / ${lngLat.lng.toFixed(6)}°`;
          const coordenadasInput = document.getElementById('coordenadas');
          const previewCoordenadas = document.getElementById('preview-coordenadas');
          if (coordenadasInput) coordenadasInput.value = coordText;
          if (previewCoordenadas && !document.getElementById('hide-coordinates')?.checked) {
              previewCoordenadas.textContent = coordText;
          }
          lastKnownMarkerPosition = lngLat;
      };
   
      const markerColor = '#ff0000';
      const selectedPinData = pinOptions[pinType];
   
      if (pinType === 'default') {
          const pinScale = (window.innerWidth <= 768) ? 0.6 : 1.0;
          marker = new mapboxgl.Marker({ color: markerColor, draggable: true, scale: pinScale })
              .setLngLat(position)
              .on('dragend', onDragEnd)
              .addTo(map);
      } else if (selectedPinData && selectedPinData.iconClass) {
          const el = document.createElement('div');
          el.className = 'custom-marker';
          el.innerHTML = `<i class="${selectedPinData.iconClass}"></i>`;
         
          if (window.innerWidth <= 768) {
              el.style.fontSize = '14px';
          } else {
              el.style.fontSize = '24px';
          }
         
          el.style.color = markerColor;
          marker = new mapboxgl.Marker({ element: el, draggable: true })
              .setLngLat(position)
              .on('dragend', onDragEnd)
              .addTo(map);
      }
      lastKnownMarkerPosition = position;
  }


  function setupVisualModelSelector() {
      const visualOptions = document.querySelectorAll('.visual-model-option');
      const hiddenSelect = document.getElementById('modelo-select');
   
      if (!visualOptions.length || !hiddenSelect) return;
   
      visualOptions.forEach(option => {
          option.addEventListener('click', () => {
              visualOptions.forEach(opt => opt.classList.remove('selected'));
              option.classList.add('selected');
              const selectedModel = option.dataset.model;
              hiddenSelect.value = selectedModel;
              hiddenSelect.dispatchEvent(new Event('change'));
             
              scrollToMapPreview();
          });
      });
  }
 
  function applySelectedFont() {
      const fontSelect = document.getElementById('font-select');
      const textElements = document.querySelectorAll('.poster-text-overlay h2, .poster-text-overlay p');
      if (!fontSelect || textElements.length === 0) return;
      const fontClass = fontSelect.value;
      textElements.forEach(el => { if (!el) return; el.classList.remove('fonte1', 'fonte2', 'fonte3', 'fonte4', 'fonte5', 'fonte6', 'fonte7'); if (fontClass) el.classList.add(fontClass); });
      applyCurrentModelStyle();
  }
 
  function setupMapInteraction() {
      const searchButton = document.getElementById('search-button'); const searchInput = document.getElementById('search'); const suggestionsContainer = document.getElementById('search-suggestions');
      const tituloInput = document.getElementById('titulo'); const subtituloInput = document.getElementById('subtitulo'); const previewTitulo = document.getElementById('preview-titulo');
      const previewSubtitulo = document.getElementById('preview-subtitulo'); const coordenadasInput = document.getElementById('coordenadas'); const previewCoordenadas = document.getElementById('preview-coordenadas');
      const hideCoordinatesCheckbox = document.getElementById('hide-coordinates'); const pinSelect = document.getElementById('pin-select'); const fontSelect = document.getElementById('font-select');
     
      function clearSuggestions() { suggestionsContainer.innerHTML = ''; suggestionsContainer.style.display = 'none'; }
     
      function updateUIWithLocation(centerCoords, placeName, fallbackTitle = 'Localização Personalizada') {
          const postSearchZoomDesktop = 10;
          const MOBILE_ZOOM_DECREASE_FACTOR = 0.62;
          let currentPostSearchZoom = postSearchZoomDesktop;
          if (window.innerWidth <= 768) {
              currentPostSearchZoom = Math.max(0, postSearchZoomDesktop - MOBILE_ZOOM_DECREASE_FACTOR);
          }
       
          map.flyTo({ center: centerCoords, zoom: currentPostSearchZoom });
          lastSearchedLngLat = { lng: centerCoords[0], lat: centerCoords[1] };
         
          const pNP = placeName ? placeName.split(',') : [];
          const mT = pNP.length > 0 ? pNP[0].trim() : fallbackTitle;
          const sT = pNP.length > 1 ? pNP.slice(1).join(',').trim() : (placeName ? '' : 'Coords inseridas');
          tituloInput.value = mT;
          subtituloInput.value = sT;
          previewTitulo.textContent = mT;
          previewSubtitulo.textContent = sT;
          const lat = centerCoords[1].toFixed(6);
          const lng = centerCoords[0].toFixed(6);
          const cT = `${lat}° / ${lng}°`;
          coordenadasInput.value = cT;
          if (previewCoordenadas) {
              previewCoordenadas.textContent = cT;
              previewCoordenadas.style.display = hideCoordinatesCheckbox.checked ? 'none' : 'block';
          }
          updateMapMarker();
          applyCurrentModelStyle();
          clearSuggestions();
         
          scrollToMapPreview();
      }
     
      function parseCoordinates(input) { const cI = input.replace(/[°'"]/g, '').replace(/;/g, ',').replace(/\s+/g, ' ').trim(); const r = /^(-?\d{1,3}(\.\d+)?)[,\s]+(-?\d{1,3}(\.\d+)?)$/; const m = cI.match(r); if (m) { const v1=parseFloat(m[1]); const v2=parseFloat(m[3]); if (v1>=-90 && v1<=90 && v2>=-180 && v2<=180) return [v2,v1]; if (v2>=-90 && v2<=90 && v1>=-180 && v1<=180) return [v1,v2]; } return null; }
     
      searchButton.addEventListener('click', () => { const q = searchInput.value.trim(); if (!q) { clearSuggestions(); return; } clearSuggestions(); const pC = parseCoordinates(q); if (pC) { const [lng, lat] = pC; fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${mapboxgl.accessToken}&types=place,locality,neighborhood,address,poi&language=pt`).then(r => r.json()).then(d => { let p = (d.features && d.features.length > 0) ? (d.features[0].place_name_pt || d.features[0].place_name) : ''; updateUIWithLocation([lng, lat], p, 'Coords Específicas'); }).catch(e => { console.error('Erro Geo Reverso:', e); updateUIWithLocation([lng, lat], '', 'Erro busca nome'); }); } else { const c = map.getCenter(); const p = `${c.lng},${c.lat}`; const t = 'poi,place,locality,address,neighborhood'; fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(q)}.json?access_token=${mapboxgl.accessToken}&proximity=${p}&types=${t}&language=pt`).then(r => r.json()).then(d => { if (d.features && d.features.length > 0) { if (d.features.length === 1) { const r = d.features[0]; updateUIWithLocation(r.center, r.place_name_pt || r.place_name); } else { const ul = document.createElement('ul'); d.features.slice(0, 5).forEach(f => { const li = document.createElement('li'); const p = f.place_name_pt || f.place_name; li.textContent = p; li.dataset.center = JSON.stringify(f.center); li.dataset.placeName = p; li.addEventListener('click', (ev) => { ev.stopPropagation(); const c=JSON.parse(ev.target.dataset.center); const n=ev.target.dataset.placeName; searchInput.value = n; updateUIWithLocation(c, n); }); ul.appendChild(li); }); suggestionsContainer.innerHTML = ''; suggestionsContainer.appendChild(ul); suggestionsContainer.style.display = 'block'; } } else { previewTitulo.textContent = 'Local não encontrado'; previewSubtitulo.textContent = ''; previewCoordenadas.textContent = ''; if (marker) { marker.remove(); marker = null; } } }).catch(e => { clearSuggestions(); previewTitulo.textContent = 'Erro na busca'; }); } });
     
      document.addEventListener('click', (e) => { if (!suggestionsContainer.contains(e.target) && e.target !== searchInput && e.target !== searchButton) { clearSuggestions(); } });
      searchInput.addEventListener('input', () => { if (!searchInput.value) { clearSuggestions(); } });
     
      pinSelect.addEventListener('change', () => {
          updateMapMarker();
          scrollToMapPreview();
      });
 
      function limparTexto(texto) { return texto.replace(/[^a-zA-Z0-9\s\u00C0-\u00FF.,\-!?:;'"@&()]/g, ''); }
   
      function aplicarFiltro(inputElement, previewElement) {
          const valorOriginal = inputElement.value;
          const valorLimpo = limparTexto(valorOriginal);
          if (valorOriginal !== valorLimpo) {
              const cursorPosition = inputElement.selectionStart;
              inputElement.value = valorLimpo;
              inputElement.setSelectionRange(Math.max(0, cursorPosition - 1), Math.max(0, cursorPosition - 1));
          }
          if (previewElement) { previewElement.textContent = valorLimpo; }
      }
   
      tituloInput.addEventListener('input', function(e) { aplicarFiltro(e.target, previewTitulo); });
      subtituloInput.addEventListener('input', function(e) { aplicarFiltro(e.target, previewSubtitulo); });
     
      hideCoordinatesCheckbox.addEventListener('change', (e) => { if(previewCoordenadas) { previewCoordenadas.style.display = e.target.checked ? 'none' : 'block'; if (!e.target.checked && !previewCoordenadas.textContent && coordenadasInput.value) previewCoordenadas.textContent = coordenadasInput.value; } });
     
      if (fontSelect) {
          fontSelect.addEventListener('change', () => {
              applySelectedFont();
              scrollToMapPreview();
          });
      }
  }
 
  function setupColorSelection() {
      const colorSwatches = document.querySelectorAll('.color-options .color-swatch');
      const colorNameDisplay = document.getElementById('selected-color-name');
   
      if (colorSwatches.length === 0) return;
   
      function updateColorName() {
          if (!colorNameDisplay) return;
          const activeSwatch = document.querySelector('.color-options .color-swatch.active');
          if (activeSwatch) {
              colorNameDisplay.textContent = `Cor: ${activeSwatch.dataset.styleName}`;
          }
      }
   
      colorSwatches.forEach(swatch => {
          swatch.addEventListener('click', function() {
              colorSwatches.forEach(s => s.classList.remove('active'));
              this.classList.add('active');
   
              selectedStyleName = this.dataset.styleName;
              selectedTextColor = this.dataset.textColor;
              const newStyleUrl = this.dataset.styleUrl;
              if (newStyleUrl) {
                  map.setStyle(newStyleUrl);
                  applyCurrentModelStyle();
              }
   
              updateColorName();
              scrollToMapPreview();
          });
      });
  }
 
  function setupModeloSelection() {
       const mS = document.getElementById('modelo-select');
       if (!mS) return;
       mS.addEventListener('change', applyCurrentModelStyle);
  }
 
 function applyCurrentModelStyle() {
      const mS = document.getElementById('modelo-select');
      const mCE = document.getElementById('poster-map-container');
      const tOE = document.querySelectorAll('.poster-text-overlay h2, .poster-text-overlay p');
      const posterMap = document.getElementById('poster-map'); // Seleciona o mapa


      if (!mS || !mCE || tOE.length === 0) return;
     
      const sM = mS.value;
      mCE.classList.remove('modelo-1', 'modelo-2', 'modelo-3', 'modelo-4');
      mCE.classList.add(sM);
     
      tOE.forEach(el => { if (el) el.style.color = selectedTextColor; });
     
      // FIX DO CORAÇÃO vs PASPATUR: Limpa o estilo forçado se for coração
      if (sM === 'modelo-4' && posterMap) {
          posterMap.style.width = '';
          posterMap.style.height = '';
          posterMap.style.top = '';
          posterMap.style.left = '';
      } else {
          // Se for modelo normal, reavalia a caixinha do paspatur
          const borderToggle = document.getElementById('toggle-border');
          if (borderToggle && posterMap) {
              borderToggle.dispatchEvent(new Event('change'));
          }
      }


      // FIX DA NÉVOA BRANCA: Força o redesenho imediato do mapa ao trocar de modelo
      if (map) {
          setTimeout(() => { map.resize(); }, 150);
      }
  }
 
  function setupFrameSelector() {
      const frameSelect = document.getElementById('frame-select');
      const frameHolder = document.getElementById('frame-holder');
   
      if (!frameSelect || !frameHolder) return;
   
      function applyFrame() {
          const selectedOption = frameSelect.options[frameSelect.selectedIndex];
          const frameUrl = selectedOption.dataset.frameUrl;
          frameHolder.style.backgroundImage = frameUrl ? `url(${frameUrl})` : 'none';
      }
   
      frameSelect.addEventListener('change', () => {
          applyFrame();
          scrollToMapPreview();
      });
  }


  // =================================================================== */
  //                     NOVA FUNÇÃO: CONTROLE DO PASPATUR ISOLADO       */
  // =================================================================== */
function setupBorderToggle() {
      const borderToggle = document.getElementById('toggle-border');
      const posterMap = document.getElementById('poster-map');
      const modeloSelect = document.getElementById('modelo-select');
      if (!borderToggle || !posterMap) return;


      borderToggle.addEventListener('change', function() {
          // Se for o Coração, deixa o CSS trabalhar sozinho
          if (modeloSelect && modeloSelect.value === 'modelo-4') {
              posterMap.style.width = '';
              posterMap.style.height = '';
              posterMap.style.top = '';
              posterMap.style.left = '';
              if (map) { setTimeout(() => { map.resize(); }, 150); }
              return;
          }


          if (this.checked) {
              // 1. REMOVER PASPATUR: O JS força o mapa a colar nas bordas (100%)
              posterMap.style.width = '100%';
              posterMap.style.height = '100%';
              posterMap.style.top = '0';
              posterMap.style.left = '0';
          } else {
              // 2. VOLTAR O PASPATUR: O JS simplesmente "apaga" a ordem anterior ('').
              // Isso faz o navegador ler automaticamente o seu CSS original
              // (20px no PC e 10px no mobile), resolvendo o bug da borda grossa!
              posterMap.style.width = '';
              posterMap.style.height = '';
              posterMap.style.top = '';
              posterMap.style.left = '';
          }
         
          // Avisa o Mapbox para ele se redesenhar no novo tamanho
          if (map) {
              setTimeout(() => { map.resize(); }, 150);
          }
      });
  }
 
 
  function setupAddToCart() {
      let addToCartButton = null;
      let productForm = document.querySelector('form[action="/cart/add"][id^="product-form"]') || document.querySelector('form[action="/cart/add"]');
      if (productForm) { addToCartButton = productForm.querySelector('[type="submit"], button[name="add"]'); }
      if (!addToCartButton) { addToCartButton = document.querySelector('.product-form__submit, button#add-to-cart, [data-add-to-cart]'); }
      if (addToCartButton && !productForm) { productForm = addToCartButton.closest('form'); }
      if (!addToCartButton || !productForm) return;
 
      function submitFormData() {
          if (!productForm || !map || !map.isStyleLoaded()) return;
         
          const MAPBOX_ACCESS_TOKEN = mapboxgl.accessToken;
          const center = map.getCenter();
          const currentInteractiveZoom = map.getZoom();
          const bearing = map.getBearing();
          const pitch = map.getPitch();
         
          const MOBILE_ZOOM_DECREASE_FACTOR = 0.62;
          let baseZoomForStaticAPI = currentInteractiveZoom;
          if (window.innerWidth <= 768) { baseZoomForStaticAPI = currentInteractiveZoom + MOBILE_ZOOM_DECREASE_FACTOR; }
          const ZOOM_ADJUST_FACTOR = 1.05;
          const staticZoomForAPI = baseZoomForStaticAPI + ZOOM_ADJUST_FACTOR;
          const clampedStaticZoom = Math.max(0, Math.min(22, staticZoomForAPI));
          const activeSwatch = document.querySelector('.color-options .color-swatch.active');
          const styleUrl = activeSwatch ? activeSwatch.dataset.styleUrl : initialStyleUrl;
          const pinSelectEl = document.getElementById('pin-select');
          const fontSelectEl = document.getElementById('font-select');
          const tituloInputEl = document.getElementById('titulo');
          const subtituloInputEl = document.getElementById('subtitulo');
          const hideCoordinatesCheckboxEl = document.getElementById('hide-coordinates');
          const coordenadasInputEl = document.getElementById('coordenadas');
          const modeloSelectEl = document.getElementById('modelo-select');
          const searchInputEl = document.getElementById('search');
          let pinLng = center.lng; let pinLat = center.lat;
          if (marker) { const mLL = marker.getLngLat(); pinLng = mLL.lng; pinLat = mLL.lat; }
          const pinType = pinSelectEl ? pinSelectEl.value : 'none';
          const pinTypeText = pinSelectEl ? pinSelectEl.options[pinSelectEl.selectedIndex].text : 'Sem PIN';
          let username = ''; let styleId = '';
          if (styleUrl && styleUrl.includes("mapbox://styles/")) { const p = styleUrl.replace("mapbox://styles/", "").split('/'); if (p.length >= 2) { username = p[0]; styleId = p[1]; } }
          let pinString = "";
          const selectedPinData = pinOptions[pinType];
          if (pinType === 'default') { pinString = `pin-l-marker+ff0000(${pinLng.toFixed(7)},${pinLat.toFixed(7)})`; }
          else if (selectedPinData && selectedPinData.imageUrl) { const encodedImageUrl = encodeURIComponent(selectedPinData.imageUrl); pinString = `url-${encodedImageUrl}(${pinLng.toFixed(7)},${pinLat.toFixed(7)})`; }
         
          const OUTPUT_WIDTH = 905;
          const OUTPUT_HEIGHT = 1280;
          const USE_AT_2X = true;
          const resolutionString = `${OUTPUT_WIDTH}x${OUTPUT_HEIGHT}${USE_AT_2X ? '@2x' : ''}`;
          const viewString = `${center.lng.toFixed(7)},${center.lat.toFixed(7)},${clampedStaticZoom.toFixed(2)},${bearing.toFixed(2)},${pitch.toFixed(2)}`;
          const queryParams = `?access_token=${MAPBOX_ACCESS_TOKEN}&attribution=false&logo=false`;
          const baseUrl = `https://api.mapbox.com/styles/v1/${username}/${styleId}/static/`;
          let finalStaticUrl = "";
          if (pinString !== "") { finalStaticUrl = `${baseUrl}${pinString}/${viewString}/${resolutionString}${queryParams}`; }
          else { finalStaticUrl = `${baseUrl}${viewString}/${resolutionString}${queryParams}`; }
         
          addOrUpdateHiddenInput(productForm, 'properties[_static_map_url]', finalStaticUrl);
          addOrUpdateHiddenInput(productForm, 'properties[_ref_center_lng]', center.lng.toFixed(7));
          addOrUpdateHiddenInput(productForm, 'properties[_ref_center_lat]', center.lat.toFixed(7));
          addOrUpdateHiddenInput(productForm, 'properties[_ref_zoom]', clampedStaticZoom.toFixed(2));
          addOrUpdateHiddenInput(productForm, 'properties[_ref_zoom_base_for_api]', baseZoomForStaticAPI.toFixed(2));
          addOrUpdateHiddenInput(productForm, 'properties[_ref_zoom_interactive]', currentInteractiveZoom.toFixed(2));
          addOrUpdateHiddenInput(productForm, 'properties[_ref_bearing]', bearing.toFixed(2));
          addOrUpdateHiddenInput(productForm, 'properties[_ref_pitch]', pitch.toFixed(2));
          if (pinType !== 'none') { addOrUpdateHiddenInput(productForm, 'properties[_pin_lng]', pinLng.toFixed(7)); addOrUpdateHiddenInput(productForm, 'properties[_pin_lat]', pinLat.toFixed(7)); }
          else { const oldPinLng = productForm.querySelector('input[type="hidden"][name="properties[_pin_lng]"]'); if(oldPinLng) oldPinLng.remove(); const oldPinLat = productForm.querySelector('input[type="hidden"][name="properties[_pin_lat]"]'); if(oldPinLat) oldPinLat.remove(); }
          addOrUpdateHiddenInput(productForm, 'properties[Localização (Busca)]', searchInputEl ? searchInputEl.value : 'N/A');
          addOrUpdateHiddenInput(productForm, 'properties[PIN Selecionado]', pinTypeText);
          addOrUpdateHiddenInput(productForm, 'properties[Fonte Selecionada]', fontSelectEl ? fontSelectEl.options[fontSelectEl.selectedIndex].text : 'Gourmet Hearth');
          addOrUpdateHiddenInput(productForm, 'properties[Título Pôster]', tituloInputEl ? tituloInputEl.value : '');
          addOrUpdateHiddenInput(productForm, 'properties[Subtítulo Pôster]', subtituloInputEl ? subtituloInputEl.value : '');
          addOrUpdateHiddenInput(productForm, 'properties[Cor/Estilo Mapa]', selectedStyleName);
          addOrUpdateHiddenInput(productForm, 'properties[Modelo Layout]', modeloSelectEl ? modeloSelectEl.options[modeloSelectEl.selectedIndex].text : 'Modelo 1');
          const coordenadasFieldName = 'properties[Coordenadas Visíveis]';
          if (hideCoordinatesCheckboxEl && !hideCoordinatesCheckboxEl.checked && coordenadasInputEl && coordenadasInputEl.value) { addOrUpdateHiddenInput(productForm, coordenadasFieldName, coordenadasInputEl.value); }
          else { const existing = productForm.querySelector(`input[name="${coordenadasFieldName}"]`); if (existing) existing.remove(); }
          const frameSelectEl = document.getElementById('frame-select');
          if (frameSelectEl) { const selectedFrameText = frameSelectEl.options[frameSelectEl.selectedIndex].text; addOrUpdateHiddenInput(productForm, 'properties[Moldura]', selectedFrameText); }
          const borderToggleEl = document.getElementById('toggle-border');
          if (borderToggleEl) { const paspaturStatus = borderToggleEl.checked ? 'Sem Paspatur (Borda Removida)' : 'Com Paspatur (Padrão)'; addOrUpdateHiddenInput(productForm, 'properties[Paspatur]', paspaturStatus); }
      }
     
      const captureAndSubmitHandler = async (event) => {
          event.preventDefault();
 
          const buttonLabel = addToCartButton.querySelector('.product-form__submit-label, .button__text') || addToCartButton;
          const originalButtonText = buttonLabel.textContent;
          addToCartButton.disabled = true;
          buttonLabel.textContent = "Preparando...";
         
          const realVariantId = productForm.querySelector('input[name="id"]').value;
          const realVariant = meta.product.variants.find(v => v.id == realVariantId);
 
          if (!realVariant) {
              alert("Por favor, selecione as opções do produto.");
              addToCartButton.disabled = false; buttonLabel.textContent = originalButtonText;
              return;
          }
 
          buttonLabel.textContent = "Adicionando...";
 
          submitFormData();
 
          const formData = new FormData(productForm);
          const properties = {};
          for (let [key, value] of formData.entries()) {
              if (key.startsWith('properties[')) {
                  const propName = key.substring(11, key.length - 1);
                  properties[propName] = value;
              }
          }
 
          if (!properties['_static_map_url']) {
              alert('Erro Crítico: Falha ao gerar a imagem do mapa. Atualize a página e tente novamente.');
              addToCartButton.disabled = false; buttonLabel.textContent = originalButtonText;
              return;
          }
 
          const payload = { items: [{ id: realVariantId, quantity: 1, properties: properties }] };
         
          try {
              const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload)
              });
              if (!response.ok) { throw new Error(await response.text()); }
              window.location.href = '/cart';
          } catch (error) {
              alert('Houve um problema ao adicionar ao carrinho.');
              addToCartButton.disabled = false; buttonLabel.textContent = originalButtonText;
          }
      };
 
      addToCartButton.addEventListener('click', captureAndSubmitHandler);
  }
 
  function setupCustomVariantEngine() {
      const customSizeSelect = document.getElementById('custom-size-select');
      const customFrameSelect = document.getElementById('frame-select');
      const productForm = document.querySelector('form[action^="/cart/add"]');
      const variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
   
      let variantsData = null;
      if (typeof meta !== 'undefined' && meta.product && meta.product.variants) {
          variantsData = meta.product.variants;
      } else {
          return;
      }
   
      if (!customSizeSelect || !customFrameSelect || !variantIdInput) return;
   
      function formatBRL(amountInCents) {
          return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amountInCents / 100);
      }

      function updatePrice() {
          const selectedSize = customSizeSelect.value;
          const selectedFrameValue = customFrameSelect.value;
          let targetTitle;
   
          if (productType && productType.trim() === 'Tela Canvas') {
              const finishOptionName = (selectedFrameValue === 'esticada-em-chassi') ? 'Canvas Apenas Impressão' : 'Canvas Com Moldura';
              targetTitle = `${finishOptionName} / ${selectedSize}`;
          } else {
              const finishOptionName = (selectedFrameValue === 'none') ? 'Apenas Impressão' : 'Com Moldura';
              targetTitle = `${finishOptionName} / ${selectedSize}`;
          }
   
          const targetVariant = variantsData.find(variant => variant.public_title === targetTitle);
   
          if (targetVariant) {
              // 1. Atualização do ID para a Shopify AJAX Cart API
              variantIdInput.value = targetVariant.id;

              // 2. Localização dos nós de preço no tema (compatível com Dawn e derivados)
              const priceContainer = document.querySelector('.price') || document.querySelector('[data-price]');
              const salePriceElement = document.querySelector('.price-item--sale') || document.querySelector('.price__sale .price-item');
              const regularPriceElement = document.querySelector('.price-item--regular') || document.querySelector('.price__regular .price-item');
              const compareAtElement = document.querySelector('.price__sale .price-item--regular, s.price-item--regular');

              const hasCompareAt = Boolean(targetVariant.compare_at_price && targetVariant.compare_at_price > targetVariant.price);

              if (hasCompareAt) {
                  // Se houver preço comparativo:
                  if (priceContainer) {
                      priceContainer.classList.add('price--on-sale');
                  }
                  if (salePriceElement) {
                      salePriceElement.textContent = formatBRL(targetVariant.price);
                  }
                  if (compareAtElement) {
                      compareAtElement.textContent = formatBRL(targetVariant.compare_at_price);
                  } else if (regularPriceElement && !salePriceElement) {
                      // Fallback caso a classe sale não exista
                      regularPriceElement.textContent = formatBRL(targetVariant.price);
                  }
              } else {
                  // Preço comum (sem promoção/comparação ativa na variante)
                  if (priceContainer) {
                      priceContainer.classList.remove('price--on-sale');
                  }
                  if (regularPriceElement) {
                      regularPriceElement.textContent = formatBRL(targetVariant.price);
                  }
                  if (salePriceElement) {
                      salePriceElement.textContent = formatBRL(targetVariant.price);
                  }
              }

              // 3. Atualização do botão de compra / esgotado
              const addToCartButton = productForm.querySelector('button[type="submit"]');
              if (addToCartButton) {
                  const buttonLabel = addToCartButton.querySelector('.product-form__submit-label, .button__text');
                  if (targetVariant.available) {
                      addToCartButton.disabled = false;
                      if (buttonLabel) buttonLabel.textContent = "Adicionar ao carrinho";
                  } else {
                      addToCartButton.disabled = true;
                      if (buttonLabel) buttonLabel.textContent = "Esgotado";
                  }
              }
          }
      }
   
      customSizeSelect.addEventListener('change', updatePrice);
      customFrameSelect.addEventListener('change', updatePrice);
   
      let attempts = 0;
      const initializer = setInterval(() => {
          const areVariantsReady = typeof meta !== 'undefined' && meta.product && meta.product.variants && meta.product.variants.length > 0;
          if (areVariantsReady) {
              clearInterval(initializer);
              updatePrice();
          } else if (++attempts > 50) {
              clearInterval(initializer);
          }
      }, 100);
  }
 
  if (map) {
      map.on('load', function() {
          setTimeout(function() {
              try {
                  setInitialPreview();
                  map.resize();
                  applyCurrentModelStyle();
                  updateMapMarker();
                  setupMapInteraction();
                  applySelectedFont();
                  setupColorSelection();
                  setupModeloSelection();
                  setupVisualModelSelector();
                  setupFrameSelector();
                  setupBorderToggle();
                  setupCustomVariantEngine(); // Reativado o motor de precificação e variantes
                  setupAddToCart();
                  map.touchZoomRotate.disableRotation();
                 
                  const frameSelect = document.getElementById('frame-select');
                  if(frameSelect) frameSelect.dispatchEvent(new Event('change'));
              } catch (e) {
                  console.error("ERRO DE INICIALIZAÇÃO:", e);
              }
          }, 300);
      });
  }
 
  window.addEventListener('resize', () => {
      if (map) { map.resize(); }
  });
 
});


// FIX DE SEGURANÇA: Garante que a tela de loading suma após o mapa inicializar
setTimeout(function() {
    const mapLoader = document.getElementById('map-loader');
    if (mapLoader) {
        mapLoader.style.transition = 'opacity 0.5s ease';
        mapLoader.style.opacity = '0';
        setTimeout(function() {
            mapLoader.style.display = 'none';
        }, 500);
    }
}, 2000);

